import { FC, SVGProps } from "react";

interface LeadIconProps extends SVGProps<SVGSVGElement> {
  color?: string;
}

const LeadIcon: FC<LeadIconProps> = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.125 13.75H3.125C1.875 13.75 1.25 13.125 1.25 11.875V6.875C1.25 5.625 1.875 5 3.125 5H6.25V11.875C6.25 13.125 6.875 13.75 8.125 13.75Z"
        stroke={color}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.31874 2.5C6.26874 2.6875 6.25 2.89375 6.25 3.125V5H3.125V3.75C3.125 3.0625 3.6875 2.5 4.375 2.5H6.31874Z"
        stroke={color}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.75 5V8.125"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.25 5V8.125"
        stroke={color}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.625 10.625H9.375C9.03125 10.625 8.75 10.9062 8.75 11.25V13.75H11.25V11.25C11.25 10.9062 10.9687 10.625 10.625 10.625Z"
        stroke={color}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.75 8.125V10.625"
        stroke={color}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.25 11.875V3.125C6.25 1.875 6.875 1.25 8.125 1.25H11.875C13.125 1.25 13.75 1.875 13.75 3.125V11.875C13.75 13.125 13.125 13.75 11.875 13.75H8.125C6.875 13.75 6.25 13.125 6.25 11.875Z"
        stroke={color}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LeadIcon;
